<script lang="ts" module>
  import type { BaseProps } from "#lib/internal/types"
  import type { Snippet } from "svelte"

  export type ArrowRootProps = BaseProps<"svg"> & {
    width?: number
    height?: number
  }
</script>

<script lang="ts">
  interface Props {
    width?: number
    height?: number
    children?: Snippet
    [key: string]: any
  }

  let { width = 10, height = 5, children, ...rest }: Props = $props()
</script>

<svg {...rest} {width} {height} viewBox="0 0 30 10" preserveAspectRatio="none">
  {#if children}
    {@render children()}
  {:else}
    <polygon points="0,0 30,0 15,10" />
  {/if}
</svg>
